import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotebook2Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H17C18.6569 22 20 20.6569 20 19V5C20 3.34315 18.6569 2 17 2H6ZM10 4H6V20H17C17.5523 20 18 19.5523 18 19V5C18 4.44772 17.5523 4 17 4H16V12.9759C16 13.8756 14.9121 14.3263 14.2758 13.69L13 12.4142L11.7242 13.69C11.0879 14.3263 10 13.8757 10 12.9759V4ZM14 4H12V10.5858L12.2858 10.3C12.6802 9.90554 13.3197 9.90553 13.7142 10.3L14 10.5858V4Z"
	})
});
export default SvgNotebook2Line;
